export const PUBLIC_ROUTE = {
  LANDING: '/',
  SIGN_IN: '/login'
};
